var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.node)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t("workflowDesigner.selectWidget")))])]):_c('div',[_c('FormHelper',{attrs:{"form":_vm.form,"config":_vm.formConfig},on:{"change":_vm.onChange},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }